import axios from 'axios';

const AI_BASE = `${process.env.REACT_APP_API_URL}/aiService/api/rag`;
// Create an Axios instance
const apiClient = axios.create({
 baseURL: AI_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, 
});

const AIapi = {
 askQuestion: (payload) => {
    return apiClient.post("/ask", payload);
  },
}
export default AIapi;